import { useEffect, useState } from 'react';

interface UseScrollDarknessOptions {
  maxDarkness?: number;
  startDarkness?: number;
}

export function useScrollDarkness(options: UseScrollDarknessOptions = {}) {
  const { maxDarkness = 0.7, startDarkness = 0 } = options;
  const [darkness, setDarkness] = useState(startDarkness);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = Math.min(scrollY / maxScroll, 1);
      
      // Calculate darkness: starts at startDarkness, increases to maxDarkness as we scroll down
      const newDarkness = startDarkness + (scrollProgress * (maxDarkness - startDarkness));
      setDarkness(newDarkness);
    };

    // Initial call
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [maxDarkness, startDarkness]);

  return darkness;
}
